import React from 'react';

/** A single-hue radial gauge — track is a lighter step of the same ramp
 * (per the mark spec: state should read across the whole ring, not just
 * the filled arc), rounded cap, center label so the value never depends
 * on color alone. */
export default function RadialProgress({ value = 0, size = 64, strokeWidth = 6, color = '#6739e0', trackColor = '#ece8fe' }) {
  const clamped = Math.max(0, Math.min(100, value ?? 0));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (clamped / 100) * circumference;

  return (
    <div className="relative inline-flex items-center justify-center shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90" role="img" aria-label={`${Math.round(clamped)}%`}>
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={trackColor} strokeWidth={strokeWidth} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 0.6s ease' }}
        />
      </svg>
      <span className="absolute text-sm font-display font-bold text-gray-800 tabular-nums">{Math.round(clamped)}%</span>
    </div>
  );
}
